package com.kanati.admin.features.events

import com.kanati.shared.ticket.TicketStatus
import com.kanati.shared.ticket.TicketValidationOutcome
import com.kanati.shared.ticket.TicketValidationResponse
import kotlin.js.Date

fun ticketPriceAmount(input: String): Int? {
    val normalized = input.trim().removePrefix("$").replace(",", "")
    if (!Regex("(?:[0-9]+(?:\\.[0-9]{0,2})?|\\.[0-9]{1,2})").matches(normalized)) return null
    val dollars = normalized.substringBefore('.').ifEmpty { "0" }.toLongOrNull() ?: return null
    if (dollars > Int.MAX_VALUE / 100) return null
    val cents = normalized.substringAfter('.', "").padEnd(2, '0').toInt()
    return (dollars * 100 + cents).takeIf { it <= Int.MAX_VALUE }?.toInt()
}

fun eventTimeError(startIso: String?, endIso: String?): String? {
    if (startIso == null || endIso == null) return "Choose valid start and end dates and times."
    val start = Date(startIso).getTime()
    val end = Date(endIso).getTime()
    return when {
        start.isNaN() || end.isNaN() -> "Choose valid start and end dates and times."
        end <= start -> "End date and time must be later than the start."
        else -> null
    }
}

fun TicketValidationResponse.isOnlineAdmission(): Boolean =
    success && outcome == TicketValidationOutcome.GRANTED && ticketStatus in setOf(TicketStatus.USED, TicketStatus.ADMITTED)

fun TicketValidationResponse.entryMessage(): String = when {
    isOnlineAdmission() -> "Admitted · $message"
    !success && outcome == TicketValidationOutcome.DENIED && ticketStatus in setOf(TicketStatus.USED, TicketStatus.ADMITTED) ->
        "Denied · already used. Do not admit again. $message"
    !success && outcome == TicketValidationOutcome.DENIED -> "Denied · $message"
    else -> "No online admission confirmed. Pause admission and review the result. $message"
}
